const initState = {
  adPromotionPlanSwitchTab: 0,
  transformFactorSelect: null,
  tracking_source_type: null,
  tracking_source_id: null,
  tracking_source_name: null // 自行增加的数据，非必传
}
const state = {
  ...initState,
  initState() {
    return initState
  }
}
const mutations = {
  switchTab(state, currentTab) {
    state.adPromotionPlanSwitchTab = currentTab
  },
  // 获取转化归因选项
  getTransformFactorSelect(state, data) {
    state.transformFactorSelect = data
    console.log(state.transformFactorSelect, '我是transformFactorSelect选项')
  },
  getTrackingSourceType(state, data) {
    state.tracking_source_type = data
    console.log(state.tracking_source_type, '我是tracking_source_type')
  },
  getTrackingSourceId(state, data) {
    state.tracking_source_id = data
    console.log(state.tracking_source_id, '我是tracking_source_id')
  },
  getTrackingSourceName(state, data) {
    state.tracking_source_name = data
    console.log(state.tracking_source_id, '我是tracking_source_name自行增加的数据')
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
